// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Kullanıcılar',
  subtitle: 'Sistem kullanıcılarını yönetin',
  newUser: 'Yeni Kullanıcı',
  editUser: 'Kullanıcı Düzenle',
  addUser: 'Yeni Kullanıcı Ekle',
  userDetails: 'Kullanıcı Detayları',
  username: 'Kullanıcı Adı',
  fullName: 'Ad Soyad',
  password: 'Şifre',
  newPassword: 'Yeni Şifre',
  role: 'Rol',
  roleAdmin: 'Yönetici',
  roleManager: 'Müdür',
  roleUser: 'Kullanıcı',
  lastLogin: 'Son Giriş',
  neverLoggedIn: 'Hiç giriş yapmadı',
  searchPlaceholder: 'Kullanıcı ara...',
  noUsers: 'Henüz kullanıcı bulunmuyor',
  userCreated: 'Kullanıcı başarıyla oluşturuldu',
  userUpdated: 'Kullanıcı başarıyla güncellendi',
  userDeleted: 'Kullanıcı başarıyla silindi',
  fetchError: 'Kullanıcılar getirilemedi',
  createError: 'Kullanıcı oluşturulamadı',
  updateError: 'Kullanıcı güncellenemedi',
  deleteError: 'Kullanıcı silinemedi',
  confirmDelete: 'Bu kullanıcıyı silmek istediğinizden emin misiniz?'
};
